import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";

const BASE_URL      = "https://senutour.com/api";
const CLOUD_NAME    = "dhs2cu6vv";
const UPLOAD_PRESET = "senutour_unsigned";

const getToken = () => localStorage.getItem("token");
const getUser  = () => JSON.parse(localStorage.getItem("user") || "{}");

// ── Icônes SVG ───────────────────────────────────────────────
const IcGrid  = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>;
const IcShop  = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 0 1-8 0"/></svg>;
const IcBox   = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/></svg>;
const IcStar  = () => <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>;
const IcEdit  = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>;
const IcTrash = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6"/><path d="M10 11v6"/><path d="M14 11v6"/></svg>;
const IcUpload= () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><polyline points="16 16 12 12 8 16"/><line x1="12" y1="12" x2="12" y2="21"/><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"/></svg>;
const IcX     = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>;
const IcUser  = () => <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="1.8" strokeLinecap="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>;
const IcWA    = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z"/></svg>;

// ── Constantes ────────────────────────────────────────────────
const TYPES_ARTISAN   = ["Bijouterie", "Tissage", "Sculpture", "Poterie", "Maroquinerie", "Peinture", "Autre"];
const CATEGORIES_PROD = ["Bijouterie", "Tissage / Wax", "Sculpture / Bois", "Poterie", "Maroquinerie", "Peinture / Art", "Accessoires", "Autre"];
const VILLES          = ["Dakar", "Diamniadio", "Saly", "Saint-Louis", "Ziguinchor", "Thiès", "Touba", "Kaolack"];
const SPEC_LISTE      = ["Sculptures en bois", "Bijoux en argent", "Bijoux en or", "Tissus wax", "Bazin riche", "Maroquinerie", "Poterie traditionnelle", "Peintures sur verre", "Peintures sur sable", "Vannerie", "Broderie", "Indigo", "Masques", "Instruments de musique"];

const PROFIL_VIDE = { nom: "", description: "", type: "Bijouterie", ville: "Dakar", adresse: "", telephone: "", whatsapp: "", prixMoyen: "", horaires: "", specialites: [], disponible: true };
const PRODUIT_VIDE = { nom: "", categorie: "Bijouterie", prix: "", stock: "", description: "" };

const formatPrix = (p) => p ? Number(p).toLocaleString("fr-FR") + " F" : "—";

const ONGLETS = [
  { id: "dashboard", label: "Vue générale", Icon: IcGrid },
  { id: "profil",    label: "Mon profil",   Icon: IcShop },
  { id: "produits",  label: "Mes produits", Icon: IcBox },
  { id: "avis",      label: "Avis clients", Icon: IcStar },
];

export default function ArtisanDashboard() {
  const navigate  = useNavigate();
  const user      = getUser();
  const fileRef   = useRef();
  const fileProdRef = useRef();

  const [onglet, setOnglet]         = useState("dashboard");
  const [artisan, setArtisan]       = useState(null);
  const [produits, setProduits]     = useState([]);
  const [loading, setLoading]       = useState(true);

  // ── Formulaire profil ─────────────────────────────────────
  const [showProfil, setShowProfil] = useState(false);
  const [form, setForm]             = useState(PROFIL_VIDE);
  const [photos, setPhotos]         = useState([]);
  const [uploading, setUploading]   = useState(false);
  const [saving, setSaving]         = useState(false);

  // ── Formulaire produit ────────────────────────────────────
  const [showProduit, setShowProduit]   = useState(false);
  const [prodForm, setProdForm]         = useState(PRODUIT_VIDE);
  const [prodPhotos, setProdPhotos]     = useState([]);
  const [uploadingP, setUploadingP]     = useState(false);
  const [savingP, setSavingP]           = useState(false);
  const [editProdId, setEditProdId]     = useState(null);

  // ── Chargement ────────────────────────────────────────────
  useEffect(() => {
    const charger = async () => {
      try {
        // On cherche le profil artisan lié à cet utilisateur
        const res = await fetch(`${BASE_URL}/artisans/mes-artisans`, {
          headers: { Authorization: `Bearer ${getToken()}` },
        });
        const data = await res.json();
        if (Array.isArray(data) && data.length > 0) {
          const a = data[0];
          setArtisan(a);
          setForm({
            nom: a.nom || "", description: a.description || "", type: a.type || "Bijouterie",
            ville: a.ville || "Dakar", adresse: a.adresse || "", telephone: a.telephone || "",
            whatsapp: a.whatsapp || "", prixMoyen: a.prixMoyen || "", horaires: a.horaires || "",
            specialites: Array.isArray(a.specialites) ? a.specialites : [], disponible: a.disponible ?? true,
          });
          setPhotos(Array.isArray(a.images) ? a.images : []);
          // Produits mockés côté artisan (pas de modèle Produit séparé pour l'instant)
          // On les stocke dans localStorage pour le MVP
          const stored = localStorage.getItem(`artisan_produits_${a.id}`);
          if (stored) setProduits(JSON.parse(stored));
        }
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    charger();
  }, []);

  // ── Upload photos ─────────────────────────────────────────
  const uploadPhotos = async (files, setter, setLoad) => {
    setLoad(true);
    try {
      const urls = await Promise.all(files.map(async (file) => {
        const fd = new FormData();
        fd.append("file", file); fd.append("upload_preset", UPLOAD_PRESET);
        const r = await fetch(`https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`, { method: "POST", body: fd });
        const d = await r.json(); return d.secure_url;
      }));
      setter(prev => [...prev, ...urls]);
    } catch { alert("Erreur upload."); }
    finally { setLoad(false); }
  };

  // ── Toggle spécialité ─────────────────────────────────────
  const toggleSpec = (s) => setForm(prev => ({
    ...prev,
    specialites: prev.specialites.includes(s) ? prev.specialites.filter(x => x !== s) : [...prev.specialites, s],
  }));

  // ── Sauvegarder profil ────────────────────────────────────
  const sauvegarderProfil = async () => {
    if (!form.nom || !form.ville) { alert("Nom et ville obligatoires."); return; }
    setSaving(true);
    try {
      const payload = { ...form, images: photos };
      let res;
      if (artisan) {
        res = await fetch(`${BASE_URL}/artisans/${artisan.id}`, {
          method: "PUT",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
          body: JSON.stringify(payload),
        });
      } else {
        res = await fetch(`${BASE_URL}/artisans`, {
          method: "POST",
          headers: { "Content-Type": "application/json", Authorization: `Bearer ${getToken()}` },
          body: JSON.stringify(payload),
        });
      }
      const data = await res.json();
      if (res.ok) {
        setArtisan(data.artisan || data);
        setShowProfil(false);
        alert(artisan ? "Profil mis à jour !" : "Profil créé !");
      } else alert(data.message || "Erreur.");
    } catch { alert("Erreur serveur."); }
    finally { setSaving(false); }
  };

  // ── Sauvegarder produit (localStorage MVP) ────────────────
  const sauvegarderProduit = () => {
    if (!prodForm.nom || !prodForm.prix) { alert("Nom et prix obligatoires."); return; }
    setSavingP(true);
    setTimeout(() => {
      let newProduits;
      if (editProdId !== null) {
        newProduits = produits.map(p => p.id === editProdId ? { ...p, ...prodForm, prix: parseInt(prodForm.prix) || 0, stock: parseInt(prodForm.stock) || 0, images: prodPhotos } : p);
      } else {
        const newP = { id: Date.now(), ...prodForm, prix: parseInt(prodForm.prix) || 0, stock: parseInt(prodForm.stock) || 0, images: prodPhotos };
        newProduits = [newP, ...produits];
      }
      setProduits(newProduits);
      if (artisan) localStorage.setItem(`artisan_produits_${artisan.id}`, JSON.stringify(newProduits));
      setShowProduit(false); setProdForm(PRODUIT_VIDE); setProdPhotos([]); setEditProdId(null);
      setSavingP(false);
    }, 500);
  };

  const supprimerProduit = (id) => {
    if (!window.confirm("Supprimer ce produit ?")) return;
    const newP = produits.filter(p => p.id !== id);
    setProduits(newP);
    if (artisan) localStorage.setItem(`artisan_produits_${artisan.id}`, JSON.stringify(newP));
  };

  const ouvrirEditProduit = (p) => {
    setEditProdId(p.id);
    setProdForm({ nom: p.nom, categorie: p.categorie, prix: p.prix, stock: p.stock, description: p.description || "" });
    setProdPhotos(p.images || []);
    setShowProduit(true);
    window.scrollTo(0, 0);
  };

  const ouvrirWhatsApp = () => {
    if (!artisan?.whatsapp && !artisan?.telephone) return;
    const num = (artisan.whatsapp || artisan.telephone).replace(/\s+/g, "").replace(/^\+/, "");
    window.open(`https://wa.me/${num}`, "_blank");
  };

  const labelStyle = { display: "block", fontSize: 11, fontWeight: 700, color: "#7A5A3A", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: 6 };
  const inputStyle = { width: "100%", boxSizing: "border-box", padding: "11px 14px", border: "1.5px solid #E8DCC8", borderRadius: 10, fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, outline: "none", color: "#1C1008", background: "white" };

  if (loading) return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#FAF5EC", fontFamily: "'Space Grotesk',sans-serif", color: "#7A5A3A" }}>
      Chargement…
    </div>
  );

  return (
    <>
      <Navbar />
      <div style={{ fontFamily: "'Space Grotesk',sans-serif", background: "#FAF5EC", minHeight: "100vh", color: "#1C1008" }}>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Fraunces:ital,opsz,wght@0,9..144,700;0,9..144,800;1,9..144,400&family=Space+Grotesk:wght@300;400;500;600;700&display=swap');
          .onglet-btn { transition: all .2s; cursor: pointer; border: none; background: none; }
          .onglet-btn:hover { color: #C4441A !important; }
          .btn-primary { background: #C4441A; transition: background .2s; border: none; cursor: pointer; }
          .btn-primary:hover { background: #A03614; }
          .card-hover { transition: all .2s; }
          .card-hover:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          .pill { cursor: pointer; transition: all .15s; user-select: none; }
          .photo-zone { border: 2px dashed #E8DCC8; border-radius: 12px; padding: 28px; text-align: center; cursor: pointer; transition: border-color .2s; }
          .photo-zone:hover { border-color: #C4441A; }
          .produit-card { transition: all .2s; }
          .produit-card:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(28,16,8,0.10) !important; }
          @media(max-width:767px) { .stats-grid { grid-template-columns: 1fr 1fr !important; } .prod-grid { grid-template-columns: 1fr !important; } }
        `}</style>

        {/* ── HEADER ── */}
        <div style={{ background: "linear-gradient(135deg,#1C1008 0%,#2D1A08 100%)", padding: "48px 5% 36px", position: "relative", overflow: "hidden" }}>
          <div style={{ position: "absolute", inset: 0, backgroundImage: "radial-gradient(circle,rgba(196,68,26,.07) 1px,transparent 1px)", backgroundSize: "28px 28px" }} />
          <div style={{ maxWidth: 1100, margin: "0 auto", position: "relative", zIndex: 1 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", flexWrap: "wrap", gap: 20 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <div style={{ width: 64, height: 64, borderRadius: "50%", background: "linear-gradient(135deg,#C4441A,#E8834A)", display: "flex", alignItems: "center", justifyContent: "center", border: "3px solid rgba(255,255,255,0.2)", flexShrink: 0, overflow: "hidden" }}>
                  {(artisan?.images?.[0] || localStorage.getItem("sunutour_photo"))
                    ? <img src={artisan?.images?.[0] || localStorage.getItem("sunutour_photo")} style={{ width: "100%", height: "100%", objectFit: "cover" }} alt="profil" />
                    : <IcUser />}
                </div>
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#C4441A", textTransform: "uppercase", letterSpacing: 2, marginBottom: 4 }}>Dashboard Artisan · JOJ 2026</div>
                  <h1 style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white", margin: 0 }}>
                    {artisan ? artisan.nom : `${user.prenom || ""} ${user.nom || ""}`.trim() || "Mon profil artisan"}
                  </h1>
                  <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)", marginTop: 3 }}>
                    {artisan ? `${artisan.type} · ${artisan.ville} · ${produits.length} produit${produits.length !== 1 ? "s" : ""}` : "Créez votre profil pour être visible"}
                  </div>
                </div>
              </div>
              <div style={{ display: "flex", gap: 10 }}>
                {artisan?.whatsapp && (
                  <button onClick={ouvrirWhatsApp}
                    style={{ background: "#25D366", border: "none", borderRadius: 10, padding: "12px 18px", color: "white", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 8 }}>
                    <IcWA /> WhatsApp
                  </button>
                )}
                <button className="btn-primary" onClick={() => { setOnglet("profil"); setShowProfil(true); }}
                  style={{ color: "white", borderRadius: 10, padding: "12px 22px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, display: "flex", alignItems: "center", gap: 8, boxShadow: "0 8px 20px rgba(196,68,26,0.35)" }}>
                  <IcEdit /> {artisan ? "Modifier mon profil" : "Créer mon profil"}
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* ── ONGLETS ── */}
        <div style={{ background: "white", borderBottom: "1.5px solid #E8DCC8", padding: "0 5%", overflowX: "auto" }}>
          <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", gap: 4, minWidth: "max-content" }}>
            {ONGLETS.map(o => (
              <button key={o.id} className="onglet-btn" onClick={() => setOnglet(o.id)}
                style={{ padding: "16px 18px", fontSize: 13, fontWeight: 600, color: onglet === o.id ? "#C4441A" : "#7A5A3A", borderBottom: onglet === o.id ? "2px solid #C4441A" : "2px solid transparent", marginBottom: -1, display: "flex", alignItems: "center", gap: 6, whiteSpace: "nowrap" }}>
                <o.Icon /> {o.label}
              </button>
            ))}
          </div>
        </div>

        <div style={{ maxWidth: 1100, margin: "0 auto", padding: "36px 5% 60px" }}>

          {/* ══ VUE GÉNÉRALE ══ */}
          {onglet === "dashboard" && (
            <>
              {!artisan && (
                <div style={{ background: "rgba(196,132,26,0.06)", border: "1.5px solid rgba(196,132,26,0.25)", borderRadius: 12, padding: "20px 24px", marginBottom: 28, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ fontSize: 14, fontWeight: 700, color: "#C4841A", marginBottom: 4 }}>Profil non créé</div>
                    <div style={{ fontSize: 13, color: "#7A5A3A" }}>Créez votre profil pour apparaître sur la page Artisans et être contacté par les clients.</div>
                  </div>
                  <button className="btn-primary" onClick={() => { setOnglet("profil"); setShowProfil(true); }}
                    style={{ color: "white", borderRadius: 8, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 13, fontWeight: 700, whiteSpace: "nowrap" }}>
                    Créer mon profil →
                  </button>
                </div>
              )}

              <div className="stats-grid" style={{ display: "grid", gridTemplateColumns: "repeat(4,1fr)", gap: 16, marginBottom: 32 }}>
                {[
                  { label: "Produits",      value: produits.length,                                                      color: "#C4441A" },
                  { label: "En stock",      value: produits.filter(p => (p.stock || 0) > 0).length,                      color: "#3D6B2E" },
                  { label: "Rupture stock", value: produits.filter(p => (p.stock || 0) === 0).length,                    color: "#C4841A" },
                  { label: "Note",          value: artisan?.note ? `${artisan.note.toFixed(1)}/5` : "—",                 color: "#C4441A" },
                ].map((s, i) => (
                  <div key={i} className="card-hover" style={{ background: "white", borderRadius: 14, padding: "22px", border: "1.5px solid #E8DCC8", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                    <div style={{ fontFamily: "'Fraunces',serif", fontSize: 28, fontWeight: 800, color: s.color }}>{s.value}</div>
                    <div style={{ fontSize: 12, color: "#7A5A3A", marginTop: 6, fontWeight: 600 }}>{s.label}</div>
                  </div>
                ))}
              </div>

              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
                {/* Aperçu profil */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mon profil artisan</h3>
                    <button onClick={() => { setOnglet("profil"); setShowProfil(true); }} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>
                      {artisan ? "Modifier →" : "Créer →"}
                    </button>
                  </div>
                  {!artisan
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucun profil — créez le vôtre pour être visible !</div>
                    : (
                      <div style={{ padding: "20px 24px" }}>
                        <div style={{ display: "flex", gap: 14, marginBottom: 16 }}>
                          <div style={{ width: 56, height: 56, borderRadius: 10, overflow: "hidden", flexShrink: 0, background: "#F2E4C8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 24 }}>
                            {artisan.images?.[0] ? <img src={artisan.images[0]} alt={artisan.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "🎨"}
                          </div>
                          <div>
                            <div style={{ fontSize: 15, fontWeight: 700, color: "#1C1008" }}>{artisan.nom}</div>
                            <div style={{ fontSize: 12, color: "#7A5A3A" }}>{artisan.type} · {artisan.ville}</div>
                            {artisan.prixMoyen && <div style={{ fontSize: 13, fontWeight: 700, color: "#C4441A", marginTop: 4 }}>{artisan.prixMoyen}</div>}
                          </div>
                        </div>
                        <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 14 }}>
                          {(Array.isArray(artisan.specialites) ? artisan.specialites : []).slice(0, 4).map(s => (
                            <span key={s} style={{ fontSize: 11, fontWeight: 600, padding: "3px 10px", borderRadius: 20, background: "rgba(196,68,26,0.08)", color: "#C4441A" }}>{s}</span>
                          ))}
                        </div>
                        <span style={{ fontSize: 12, fontWeight: 700, padding: "4px 12px", borderRadius: 20, background: artisan.disponible ? "rgba(61,107,46,0.10)" : "rgba(196,68,26,0.10)", color: artisan.disponible ? "#3D6B2E" : "#C4441A" }}>
                          {artisan.disponible ? "✓ Visible sur la plateforme" : "✗ Masqué"}
                        </span>
                      </div>
                    )
                  }
                </div>

                {/* Produits récents */}
                <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ padding: "18px 24px", borderBottom: "1.5px solid #E8DCC8", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes produits</h3>
                    <button onClick={() => setOnglet("produits")} style={{ fontSize: 12, color: "#C4441A", fontWeight: 600, background: "none", border: "none", cursor: "pointer" }}>Voir tout →</button>
                  </div>
                  {produits.length === 0
                    ? <div style={{ padding: 32, textAlign: "center", color: "#7A5A3A", fontSize: 13 }}>Aucun produit — ajoutez vos créations !</div>
                    : produits.slice(0, 4).map((p, i, arr) => (
                      <div key={p.id} style={{ padding: "13px 24px", borderBottom: i < arr.length - 1 ? "1px solid #F2E4C8" : "none", display: "flex", alignItems: "center", gap: 12 }}>
                        <div style={{ width: 36, height: 36, borderRadius: 8, overflow: "hidden", flexShrink: 0, background: "#F2E4C8", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 18 }}>
                          {p.images?.[0] ? <img src={p.images[0]} alt={p.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "🛍️"}
                        </div>
                        <div style={{ flex: 1, minWidth: 0 }}>
                          <div style={{ fontSize: 13, fontWeight: 600, color: "#1C1008", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.nom}</div>
                          <div style={{ fontSize: 11, color: "#7A5A3A" }}>{p.categorie} · Stock : {p.stock || 0}</div>
                        </div>
                        <div style={{ fontFamily: "'Fraunces',serif", fontSize: 14, fontWeight: 700, color: "#C4441A" }}>{formatPrix(p.prix)}</div>
                      </div>
                    ))
                  }
                </div>
              </div>
            </>
          )}

          {/* ══ MON PROFIL ══ */}
          {onglet === "profil" && (
            <>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
                <div>
                  <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mon profil artisan</h2>
                  <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{artisan ? "Visible sur SenuTour" : "Profil non encore créé"}</p>
                </div>
                <button className="btn-primary" onClick={() => setShowProfil(!showProfil)}
                  style={{ color: "white", borderRadius: 10, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                  {showProfil ? "Annuler" : artisan ? "Modifier" : "+ Créer mon profil"}
                </button>
              </div>

              {showProfil && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", padding: "32px", marginBottom: 28, boxShadow: "0 4px 20px rgba(28,16,8,0.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 20, fontWeight: 800, color: "#1C1008", marginBottom: 24 }}>
                    {artisan ? "Modifier mon profil" : "Créer mon profil artisan"}
                  </h3>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 20px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Nom / Nom de boutique *</label>
                      <input value={form.nom} onChange={e => setForm({ ...form, nom: e.target.value })} placeholder="Ex: Bijoux Teranga" style={inputStyle} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Adresse</label>
                      <input value={form.adresse} onChange={e => setForm({ ...form, adresse: e.target.value })} placeholder="Ex: Marché Soumbédioune, Stand 14" style={inputStyle} />
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Type d'artisanat *</label>
                      <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} style={inputStyle}>
                        {TYPES_ARTISAN.map(t => <option key={t}>{t}</option>)}
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Ville *</label>
                      <select value={form.ville} onChange={e => setForm({ ...form, ville: e.target.value })} style={inputStyle}>
                        {VILLES.map(v => <option key={v}>{v}</option>)}
                      </select>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Disponible</label>
                      <select value={form.disponible ? "oui" : "non"} onChange={e => setForm({ ...form, disponible: e.target.value === "oui" })} style={inputStyle}>
                        <option value="oui">Oui — visible</option>
                        <option value="non">Non — masqué</option>
                      </select>
                    </div>
                  </div>

                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: "0 16px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Téléphone</label>
                      <input value={form.telephone} onChange={e => setForm({ ...form, telephone: e.target.value })} placeholder="+221 77 000 00 00" style={inputStyle} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>WhatsApp</label>
                      <input value={form.whatsapp} onChange={e => setForm({ ...form, whatsapp: e.target.value })} placeholder="+221 77 000 00 00" style={inputStyle} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Prix moyens</label>
                      <input value={form.prixMoyen} onChange={e => setForm({ ...form, prixMoyen: e.target.value })} placeholder="Ex: 5 000 – 50 000 FCFA" style={inputStyle} />
                    </div>
                  </div>

                  <div style={{ marginBottom: 16 }}>
                    <label style={labelStyle}>Horaires</label>
                    <input value={form.horaires} onChange={e => setForm({ ...form, horaires: e.target.value })} placeholder="Ex: Lun–Sam 9h–19h" style={inputStyle} />
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Description</label>
                    <textarea value={form.description} onChange={e => setForm({ ...form, description: e.target.value })}
                      placeholder="Décrivez votre activité, vos techniques, votre histoire…"
                      rows={4} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} />
                  </div>

                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Spécialités</label>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {SPEC_LISTE.map(s => (
                        <span key={s} className="pill" onClick={() => toggleSpec(s)}
                          style={{ padding: "6px 14px", borderRadius: 20, fontSize: 13, fontWeight: 500, border: `1.5px solid ${form.specialites.includes(s) ? "#C4441A" : "#E8DCC8"}`, background: form.specialites.includes(s) ? "rgba(196,68,26,0.08)" : "white", color: form.specialites.includes(s) ? "#C4441A" : "#7A5A3A" }}>
                          {form.specialites.includes(s) ? "✓ " : ""}{s}
                        </span>
                      ))}
                    </div>
                  </div>

                  <div style={{ marginBottom: 24 }}>
                    <label style={labelStyle}>Photos</label>
                    <div className="photo-zone" onClick={() => fileRef.current?.click()}>
                      <input ref={fileRef} type="file" multiple accept="image/*" onChange={e => uploadPhotos(Array.from(e.target.files), setPhotos, setUploading)} style={{ display: "none" }} />
                      {uploading ? <p style={{ color: "#7A5A3A", margin: 0, fontSize: 14 }}>Chargement…</p> : <><IcUpload /><p style={{ color: "#7A5A3A", margin: "8px 0 4px", fontSize: 14, fontWeight: 600 }}>Cliquez pour ajouter des photos</p></>}
                    </div>
                    {photos.length > 0 && (
                      <div style={{ display: "flex", flexWrap: "wrap", gap: 10, marginTop: 12 }}>
                        {photos.map((url, i) => (
                          <div key={i} style={{ position: "relative", width: 80, height: 80, borderRadius: 8, overflow: "hidden" }}>
                            <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            <button onClick={() => setPhotos(prev => prev.filter(p => p !== url))}
                              style={{ position: "absolute", top: 4, right: 4, background: "rgba(196,68,26,0.85)", border: "none", borderRadius: "50%", width: 20, height: 20, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "white" }}>
                              <IcX />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button onClick={() => setShowProfil(false)} style={{ background: "white", border: "1.5px solid #E8DCC8", borderRadius: 10, padding: "11px 20px", fontSize: 14, fontWeight: 600, color: "#7A5A3A", cursor: "pointer" }}>Annuler</button>
                    <button className="btn-primary" onClick={sauvegarderProfil} disabled={saving}
                      style={{ color: "white", borderRadius: 10, padding: "11px 28px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, opacity: saving ? 0.7 : 1 }}>
                      {saving ? "Enregistrement…" : "Enregistrer"}
                    </button>
                  </div>
                </div>
              )}

              {/* Aperçu profil */}
              {artisan && !showProfil && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", overflow: "hidden" }}>
                  <div style={{ height: 160, background: "linear-gradient(135deg,#1C1008,#2D1A08)", overflow: "hidden", position: "relative" }}>
                    {artisan.images?.[0] && <img src={artisan.images[0]} alt={artisan.nom} style={{ width: "100%", height: "100%", objectFit: "cover", opacity: 0.6 }} />}
                    <div style={{ position: "absolute", bottom: 16, left: 24, right: 24, display: "flex", alignItems: "flex-end", justifyContent: "space-between" }}>
                      <div>
                        <div style={{ fontFamily: "'Fraunces',serif", fontSize: 22, fontWeight: 800, color: "white" }}>{artisan.nom}</div>
                        <div style={{ fontSize: 13, color: "rgba(255,255,255,.7)" }}>{artisan.type} · {artisan.ville}</div>
                      </div>
                      <span style={{ fontSize: 12, fontWeight: 700, padding: "5px 14px", borderRadius: 20, background: artisan.disponible ? "rgba(61,107,46,0.85)" : "rgba(196,68,26,0.85)", color: "white" }}>
                        {artisan.disponible ? "Visible" : "Masqué"}
                      </span>
                    </div>
                  </div>
                  <div style={{ padding: "24px 28px" }}>
                    {artisan.description && <p style={{ fontSize: 14, color: "#7A5A3A", lineHeight: 1.7, marginBottom: 20 }}>{artisan.description}</p>}
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginBottom: 20 }}>
                      {(Array.isArray(artisan.specialites) ? artisan.specialites : []).map(s => (
                        <span key={s} style={{ fontSize: 12, fontWeight: 600, padding: "4px 12px", borderRadius: 20, background: "rgba(196,68,26,0.08)", color: "#C4441A" }}>{s}</span>
                      ))}
                    </div>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 12 }}>
                      {artisan.prixMoyen && <div style={{ background: "#FAF5EC", borderRadius: 10, padding: "12px", textAlign: "center" }}><div style={{ fontSize: 13, fontWeight: 700, color: "#C4441A" }}>{artisan.prixMoyen}</div><div style={{ fontSize: 11, color: "#7A5A3A" }}>prix moyens</div></div>}
                      {artisan.horaires && <div style={{ background: "#FAF5EC", borderRadius: 10, padding: "12px", textAlign: "center" }}><div style={{ fontSize: 12, fontWeight: 600, color: "#1C1008" }}>{artisan.horaires}</div><div style={{ fontSize: 11, color: "#7A5A3A" }}>horaires</div></div>}
                      {(artisan.whatsapp || artisan.telephone) && <div style={{ background: "#FAF5EC", borderRadius: 10, padding: "12px", textAlign: "center" }}><button onClick={ouvrirWhatsApp} style={{ background: "#25D366", border: "none", borderRadius: 8, padding: "8px 16px", color: "white", fontSize: 13, fontWeight: 700, cursor: "pointer", display: "flex", alignItems: "center", gap: 6, margin: "0 auto" }}><IcWA /> WhatsApp</button></div>}
                    </div>
                  </div>
                </div>
              )}

              {!artisan && !showProfil && (
                <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A" }}>
                  <p style={{ fontSize: 15, marginBottom: 16 }}>Vous n'avez pas encore de profil artisan.</p>
                  <button className="btn-primary" onClick={() => setShowProfil(true)} style={{ color: "white", borderRadius: 10, padding: "12px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                    + Créer mon profil
                  </button>
                </div>
              )}
            </>
          )}

          {/* ══ MES PRODUITS ══ */}
          {onglet === "produits" && (
            <>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
                <div>
                  <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Mes produits</h2>
                  <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>{produits.length} produit{produits.length !== 1 ? "s" : ""}</p>
                </div>
                <button className="btn-primary" onClick={() => { setShowProduit(!showProduit); setProdForm(PRODUIT_VIDE); setProdPhotos([]); setEditProdId(null); }}
                  style={{ color: "white", borderRadius: 10, padding: "10px 20px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                  {showProduit && editProdId === null ? "Annuler" : "+ Ajouter un produit"}
                </button>
              </div>

              {showProduit && (
                <div style={{ background: "white", borderRadius: 16, border: "1.5px solid #E8DCC8", padding: "28px", marginBottom: 24, boxShadow: "0 4px 20px rgba(28,16,8,0.08)" }}>
                  <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 18, fontWeight: 800, color: "#1C1008", marginBottom: 20 }}>
                    {editProdId ? "Modifier le produit" : "Nouveau produit"}
                  </h3>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 20px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Nom du produit *</label>
                      <input value={prodForm.nom} onChange={e => setProdForm({ ...prodForm, nom: e.target.value })} placeholder="Ex: Collier en argent sénégalais" style={inputStyle} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Catégorie</label>
                      <select value={prodForm.categorie} onChange={e => setProdForm({ ...prodForm, categorie: e.target.value })} style={inputStyle}>
                        {CATEGORIES_PROD.map(c => <option key={c}>{c}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0 16px" }}>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Prix (F CFA) *</label>
                      <input type="number" value={prodForm.prix} onChange={e => setProdForm({ ...prodForm, prix: e.target.value })} placeholder="Ex: 25000" style={inputStyle} />
                    </div>
                    <div style={{ marginBottom: 16 }}>
                      <label style={labelStyle}>Stock disponible</label>
                      <input type="number" value={prodForm.stock} onChange={e => setProdForm({ ...prodForm, stock: e.target.value })} placeholder="Ex: 5" style={inputStyle} />
                    </div>
                  </div>
                  <div style={{ marginBottom: 16 }}>
                    <label style={labelStyle}>Description</label>
                    <textarea value={prodForm.description} onChange={e => setProdForm({ ...prodForm, description: e.target.value })}
                      placeholder="Matériaux, technique, dimensions, histoire du produit…"
                      rows={3} style={{ ...inputStyle, resize: "vertical", lineHeight: 1.6 }} />
                  </div>
                  <div style={{ marginBottom: 20 }}>
                    <label style={labelStyle}>Photos du produit</label>
                    <div className="photo-zone" onClick={() => fileProdRef.current?.click()}>
                      <input ref={fileProdRef} type="file" multiple accept="image/*" onChange={e => uploadPhotos(Array.from(e.target.files), setProdPhotos, setUploadingP)} style={{ display: "none" }} />
                      {uploadingP ? <p style={{ color: "#7A5A3A", margin: 0 }}>Chargement…</p> : <><IcUpload /><p style={{ color: "#7A5A3A", margin: "8px 0 0", fontSize: 13 }}>Ajouter des photos</p></>}
                    </div>
                    {prodPhotos.length > 0 && (
                      <div style={{ display: "flex", gap: 10, marginTop: 12, flexWrap: "wrap" }}>
                        {prodPhotos.map((url, i) => (
                          <div key={i} style={{ position: "relative", width: 72, height: 72, borderRadius: 8, overflow: "hidden" }}>
                            <img src={url} alt="" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                            <button onClick={() => setProdPhotos(prev => prev.filter(p => p !== url))}
                              style={{ position: "absolute", top: 3, right: 3, background: "rgba(196,68,26,0.85)", border: "none", borderRadius: "50%", width: 18, height: 18, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", color: "white" }}>
                              <IcX />
                            </button>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
                    <button onClick={() => { setShowProduit(false); setProdForm(PRODUIT_VIDE); setProdPhotos([]); setEditProdId(null); }}
                      style={{ background: "white", border: "1.5px solid #E8DCC8", borderRadius: 10, padding: "10px 20px", fontSize: 14, fontWeight: 600, color: "#7A5A3A", cursor: "pointer" }}>Annuler</button>
                    <button className="btn-primary" onClick={sauvegarderProduit} disabled={savingP}
                      style={{ color: "white", borderRadius: 10, padding: "10px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700, opacity: savingP ? 0.7 : 1 }}>
                      {savingP ? "Enregistrement…" : "Enregistrer"}
                    </button>
                  </div>
                </div>
              )}

              {produits.length === 0 && !showProduit ? (
                <div style={{ textAlign: "center", padding: 60, color: "#7A5A3A" }}>
                  <p style={{ fontSize: 15, marginBottom: 16 }}>Aucun produit enregistré.</p>
                  <button className="btn-primary" onClick={() => setShowProduit(true)} style={{ color: "white", borderRadius: 10, padding: "12px 24px", fontFamily: "'Space Grotesk',sans-serif", fontSize: 14, fontWeight: 700 }}>
                    + Ajouter mon premier produit
                  </button>
                </div>
              ) : (
                <div className="prod-grid" style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 16 }}>
                  {produits.map(p => (
                    <div key={p.id} className="produit-card" style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", overflow: "hidden", boxShadow: "0 2px 12px rgba(28,16,8,0.06)" }}>
                      <div style={{ height: 130, background: "linear-gradient(135deg,#1C1008,#2D1A08)", overflow: "hidden", position: "relative", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 48 }}>
                        {p.images?.[0] ? <img src={p.images[0]} alt={p.nom} style={{ width: "100%", height: "100%", objectFit: "cover" }} /> : "🛍️"}
                        <span style={{ position: "absolute", top: 10, right: 10, fontSize: 11, fontWeight: 700, padding: "4px 10px", borderRadius: 20, background: (p.stock || 0) === 0 ? "rgba(196,68,26,0.85)" : "rgba(61,107,46,0.85)", color: "white" }}>
                          {(p.stock || 0) === 0 ? "Rupture" : `Stock: ${p.stock}`}
                        </span>
                      </div>
                      <div style={{ padding: 16 }}>
                        <h3 style={{ fontFamily: "'Fraunces',serif", fontSize: 14, fontWeight: 800, color: "#1C1008", margin: "0 0 4px" }}>{p.nom}</h3>
                        <div style={{ fontSize: 12, color: "#7A5A3A", marginBottom: 10 }}>{p.categorie}</div>
                        {p.description && <p style={{ fontSize: 12, color: "#7A5A3A", lineHeight: 1.5, margin: "0 0 12px", display: "-webkit-box", WebkitLineClamp: 2, WebkitBoxOrient: "vertical", overflow: "hidden" }}>{p.description}</p>}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", paddingTop: 12, borderTop: "1px solid #F2E4C8" }}>
                          <div style={{ fontFamily: "'Fraunces',serif", fontSize: 16, fontWeight: 800, color: "#C4441A" }}>{formatPrix(p.prix)}</div>
                          <div style={{ display: "flex", gap: 6 }}>
                            <button onClick={() => ouvrirEditProduit(p)} style={{ background: "rgba(196,68,26,0.08)", border: "none", borderRadius: 8, padding: "7px 10px", fontSize: 12, fontWeight: 600, color: "#C4441A", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                              <IcEdit />
                            </button>
                            <button onClick={() => supprimerProduit(p.id)} style={{ background: "rgba(196,68,26,0.06)", border: "none", borderRadius: 8, padding: "7px 10px", fontSize: 12, fontWeight: 600, color: "#C4441A", cursor: "pointer", display: "flex", alignItems: "center", gap: 4 }}>
                              <IcTrash />
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {/* ══ AVIS ══ */}
          {onglet === "avis" && (
            <>
              <div style={{ marginBottom: 24 }}>
                <h2 style={{ fontFamily: "'Fraunces',serif", fontSize: 24, fontWeight: 800, color: "#1C1008", margin: 0 }}>Avis clients</h2>
                <p style={{ fontSize: 13, color: "#7A5A3A", margin: "4px 0 0" }}>Note moyenne : <strong>{artisan?.note?.toFixed(1) || "—"}/5</strong> · {artisan?.avis || 0} avis</p>
              </div>
              <div style={{ background: "white", borderRadius: 14, border: "1.5px solid #E8DCC8", padding: "32px", textAlign: "center" }}>
                <div style={{ fontFamily: "'Fraunces',serif", fontSize: 56, fontWeight: 800, color: "#C4441A", lineHeight: 1 }}>{artisan?.note?.toFixed(1) || "—"}</div>
                <div style={{ margin: "12px 0 8px" }}>
                  {[1,2,3,4,5].map(i => <span key={i} style={{ color: i <= Math.round(artisan?.note || 0) ? "#C4441A" : "#E8DCC8", fontSize: 24 }}>★</span>)}
                </div>
                <p style={{ fontSize: 13, color: "#7A5A3A", marginTop: 12 }}>
                  {artisan ? "Les avis apparaîtront ici dès que des clients en laisseront." : "Créez votre profil pour commencer à recevoir des avis."}
                </p>
              </div>
            </>
          )}

        </div>
      </div>
      <Footer />
    </>
  );
}